import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';
import { Offer } from '../../model/offer.model';
import { OfferModel } from '../../model/OfferModel';

export const useOfferView = (id: string) => {
    return useQuery({
        ...queries.offers.detail(id),
        staleTime: Infinity,
        select: (offer: OfferModel) => {
            return new Offer({
                ...offer,
                vendorReference: offer.vendorReference ?? '',
                buyerReference: offer.buyerReference ?? '',
            }) as any as OfferModel;
        },
    });
};
